/**
 * Ouvre un nouvel onglet pour un téléchargement dont l'URL n'est connue qu'après un appel réseau.
 *
 * `window.open()` doit être appelé **synchronement** dans le gestionnaire de clic pour rester
 * rattaché au geste de l'utilisateur — l'appeler après un `await` en fait un appel différé que la
 * plupart des navigateurs bloquent ou remplacent par un onglet inerte (`about:blank` qui ne navigue
 * jamais). L'onglet est donc ouvert vide tout de suite, puis redirigé une fois l'URL obtenue.
 *
 * Trouvé en écrivant le test de bout en bout (`e2e/parcours-critique.spec.ts`) : l'onglet ouvert
 * restait sur `about:blank` de façon reproductible, dans Chromium comme dans un vrai navigateur.
 */
export function ouvrirTelechargement(obtenirUrl: () => Promise<string>): void {
  // Pas de "noopener" ici : cette option ferait retourner `null`, or c'est justement la
  // référence à l'onglet qui permet de le rediriger une fois l'URL connue.
  const onglet = window.open("", "_blank");

  void obtenirUrl()
    .then((url) => {
      if (onglet) onglet.location.href = url;
    })
    .catch(() => {
      onglet?.close();
    });
}
